import { createReducer, on } from '@ngrx/store';
import { isEqual } from 'lodash-es';
import { consumptionInvoicesInitialState, ConsumptionInvoicesState } from '@store/states/consumption-invoices.state';
import { consumptionInvoicesActions, ConsumptionInvoicesInformesActions, RehabActions } from '@store/actions/consumption-invoices.actions';

export const consumptionInvoicesReducer = createReducer(
  consumptionInvoicesInitialState,
  on(
    consumptionInvoicesActions.filterRequestList,
    (state, { filter }): ConsumptionInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        filter,
        page: {
          ...state.requestList.page,
          pageIndex: 1,
        },
      },
    })
  ),
  on(
    consumptionInvoicesActions.pageRequestList,
    (state, { page }): ConsumptionInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        page,
      },
    })
  ),
  on(
    consumptionInvoicesActions.sortRequestList,
    (state, { sort }): ConsumptionInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        sort,
      },
    })
  ),
  on(
    consumptionInvoicesActions.setRequestListError,
    (state, { error }): ConsumptionInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        error,
        data: [],
      },
    })
  ),
  on(
    consumptionInvoicesActions.setRequestList,
    (state, { data }): ConsumptionInvoicesState => ({
      ...state,
      requestList: {
        ...state.requestList,
        error: null,
        data,
      },
    })
  ),
  on(consumptionInvoicesActions.changeTab, (state, { index }): ConsumptionInvoicesState => {
    if (index >= 0 && index < state.tabs.length) {
      return {
        ...state,
        currentTab: state.tabs[index],
      };
    }
    return state;
  }),
  on(
    consumptionInvoicesActions.initFilter,
    (state, { filter }): ConsumptionInvoicesState => ({
      ...state,
      graphs: {
        ...state.graphs,
        climate: {
          ...state.graphs.climate,
          filter,
        },
        acs: {
          ...state.graphs.acs,
          filter,
        },
      },
    })
  ),
  on(
    consumptionInvoicesActions.setClimateGraphType,
    (state, { graphType }): ConsumptionInvoicesState => ({
      ...state,
      graphs: {
        ...state.graphs,
        climate: {
          ...state.graphs.climate,
          graphType,
        },
      },
    })
  ),
  on(
    consumptionInvoicesActions.setAcsGraphType,
    (state, { graphType }): ConsumptionInvoicesState => ({
      ...state,
      graphs: {
        ...state.graphs,
        acs: {
          ...state.graphs.acs,
          graphType,
        },
      },
    })
  ),
  on(consumptionInvoicesActions.setClimateFilter, (state, { filter }): ConsumptionInvoicesState => {
    const currentFilter = state.graphs.climate.filter;
    if (isEqual(currentFilter, filter)) {
      return state;
    }
    return {
      ...state,
      graphs: {
        ...state.graphs,
        climate: {
          ...state.graphs.climate,
          filter,
        },
      },
    };
  }),
  on(consumptionInvoicesActions.setClimateData, (state, { previousData, currentData }): ConsumptionInvoicesState => {
    if (!!previousData || !!currentData) {
      return {
        ...state,
        graphs: {
          ...state.graphs,
          climate: {
            ...state.graphs.climate,
            previousData,
            currentData,
            error: false,
          },
        },
      };
    }
    return {
      ...state,
      graphs: {
        ...state.graphs,
        climate: {
          ...state.graphs.climate,
          previousData: null,
          currentData: null,
          error: true,
        },
      },
    };
  }),
  on(
    consumptionInvoicesActions.setAcsGraphType,
    (state, { graphType }): ConsumptionInvoicesState => ({
      ...state,
      graphs: {
        ...state.graphs,
        acs: {
          ...state.graphs.acs,
          graphType,
        },
      },
    })
  ),
  on(consumptionInvoicesActions.setAcsFilter, (state, { filter }): ConsumptionInvoicesState => {
    const currentFilter = state.graphs.acs.filter;
    if (isEqual(currentFilter, filter)) {
      return state;
    }
    return {
      ...state,
      graphs: {
        ...state.graphs,
        acs: {
          ...state.graphs.acs,
          filter,
        },
      },
    };
  }),
  on(
    consumptionInvoicesActions.setAcsData,
    (state, { previousData, currentData }): ConsumptionInvoicesState => ({
      ...state,
      graphs: {
        ...state.graphs,
        acs: {
          ...state.graphs.acs,
          previousData,
          currentData,
          error: false,
        },
      },
    })
  ),
  // housing/rooms helpers
  on(
    RehabActions.setHousingClimate,
    (state, { data }): ConsumptionInvoicesState => ({
      ...state,
      housingClimate: data,
    })
  ),
  on(
    RehabActions.setRoomsClimate,
    (state, { data }): ConsumptionInvoicesState => ({
      ...state,
      roomsClimate: data,
    })
  ),
  on(
    RehabActions.setHousingAcs,
    (state, { data }): ConsumptionInvoicesState => ({
      ...state,
      housingAcs: data,
    })
  ),
  on(
    RehabActions.setRoomsAcs,
    (state, { data }): ConsumptionInvoicesState => ({
      ...state,
      roomsAcs: data,
    })
  ),
  on(
    consumptionInvoicesActions.setAcsError,
    (state): ConsumptionInvoicesState => ({
      ...state,
      graphs: {
        ...state.graphs,
        acs: {
          ...state.graphs.acs,
          previousData: null,
          currentData: null,
          error: true,
        },
      },
    })
  ),
  on(
    ConsumptionInvoicesInformesActions.setInformesUser,
    (state, { data }): ConsumptionInvoicesState => ({
      ...state,
      informesUser: {
        data,
        error: null,
      },
    })
  ),
  on(
    ConsumptionInvoicesInformesActions.errorInformesUser,
    (state, { error }): ConsumptionInvoicesState => ({
      ...state,
      informesUser: {
        data: [],
        error,
      },
    })
  )
);
